"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Formatter_1 = __importDefault(require("../../Formatter"));
class MonthSnapshot {
    constructor(params) {
        this.month_offset = typeof params.month_offset === 'number' ? params.month_offset : parseInt(params.month_offset);
        this.total_revenue = typeof params.total_revenue === 'number' ? params.total_revenue : parseInt(params.total_revenue);
    }
}
(function (MonthSnapshot) {
    function makeMayload(params, date) {
        return {
            month_offset: typeof params.month_offset === 'number' ? params.month_offset : parseInt(params.month_offset),
            total_revenue: typeof params.total_revenue === 'number' ? params.total_revenue : parseInt(params.total_revenue),
            date: date.format(Formatter_1.default.serverDateFormat),
        };
    }
    MonthSnapshot.makeMayload = makeMayload;
})(MonthSnapshot || (MonthSnapshot = {}));
exports.default = MonthSnapshot;
